<template>
  <div class="loading-wrapper">
    <div class="canvas-wrapper">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: [
    'percentLoaded',
  ],
  data() {
    return {
      percentFaked: 24,
      canvas: undefined,
      ctx: undefined,
      loaded: false,
      bar: undefined,
      steps: undefined,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize, false)
    this.canvas = this.$refs.canvas
    this.ctx = this.canvas.getContext('2d')
    const dpr = window.devicePixelRatio
    this.canvas.width = this.canvas.style.width * dpr
    this.canvas.height = this.canvas.style.height * dpr
    this.canvas.width = (window.innerWidth * dpr)
    this.canvas.height = (window.innerWidth * 0.2608353034) * dpr

    // this.ctx.drawImage(img, 10, 10)
    const bar = this.loadImage('/static/loading-bar.jpg', this.bar).then((img) => {
      this.bar = img
    }).catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e)
    })
    const steps = this.loadImage('/static/loading-steps.jpg', this.steps).then((img) => {
      this.steps = img
    }).catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e)
    })
    Promise.all([bar, steps]).then(() => {
      this.loaded = true
      this.drawPercent(0)
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.error(`error :${err}`)
    })
  },
  methods: {
    resize() {
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (e) => {
          reject(e)
        }
        img.src = url
      })
    },
    drawPercent(percent) {
      if (this.loaded) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx.globalCompositeOperation = 'multiply'
        // this.ctx.fillStyle = '#FFFF01'
        // this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx.drawImage(this.bar, 0, 0, this.canvas.width, this.canvas.height)
        this.ctx.drawImage(
          this.steps,
          0,
          0,
          this.steps.naturalWidth * (percent / 100),
          this.steps.naturalHeight,
          0,
          0,
          this.canvas.width * (percent / 100),
          this.canvas.height,
        )
      }
    },
  },
  watch: {
    percentLoaded(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal < 7) {
          this.drawPercent(12)
        } else if (newVal < 14) {
          this.drawPercent(18)
        } else if (newVal < 21) {
          this.drawPercent(24)
        } else if (newVal < 28) {
          this.drawPercent(29)
        } else if (newVal < 35) {
          this.drawPercent(36)
        } else if (newVal < 42) {
          this.drawPercent(42)
        } else if (newVal < 49) {
          this.drawPercent(47)
        } else if (newVal < 56) {
          this.drawPercent(53)
        } else if (newVal < 63) {
          this.drawPercent(59)
        } else if (newVal < 70) {
          this.drawPercent(65)
        } else if (newVal < 77) {
          this.drawPercent(71)
        } else if (newVal < 84) {
          this.drawPercent(76)
        } else if (newVal < 91) {
          this.drawPercent(81.5)
        } else if (newVal < 98) {
          this.drawPercent(88)
        } else if (newVal >= 98) {
          this.drawPercent(100)
        } else {
          this.drawPercent(0)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 70;
  top: 0;
  left: 0;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-color: #ffff01;

  .canvas-wrapper {
    width: 70%;
    max-width: 500px;

    canvas {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue